import React, { useState } from "react";
import { useAddMainCenterStockMutation } from "../api/starterKitApi";
import { showToast } from "../../../core/utils/alert";
import { getApiErrorMessage } from "../../../core/utils/errorHandler";

import CommonSelect from "../../../core/common/commonSelect";
import { useCourse } from "../../configuration/course/hooks/useCourse";

const AddStockModal = () => {
  const [quantity, setQuantity] = useState(0);
  const [courseId, setCourseId] = useState("");

  const { getCourseState } = useCourse();
  const { courses } = getCourseState();
  const courseOptions = courses.map(course => ({
    value: course.id.toString(),
    label: course.name,
  }));

  const [addStock, { isLoading }] = useAddMainCenterStockMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (!courseId) {
        showToast({ title: "Error", text: "Please select a course", icon: "error" });
        return;
      }
      const response = await addStock({ quantity, course_id: Number(courseId) }).unwrap();
      if (response.success) {
        showToast({
          title: "Success",
          text: "Stock added successfully",
          icon: "success",
        });
        setQuantity(0);
        // Close modal
        const modalElement = document.getElementById("add_stock");
        if (modalElement) {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && bootstrap.Modal) {
            const modal = bootstrap.Modal.getInstance(modalElement);
            modal?.hide();
          } else {
            const closeButton = modalElement.querySelector('[data-bs-dismiss="modal"]') as HTMLButtonElement;
            closeButton?.click();
          }
        }
      }
    } catch (error: any) {
      showToast({
        title: "Error",
        text: getApiErrorMessage(error) || "Failed to add stock",
        icon: "error",
      });
    }
  };

  return (
    <div className="modal fade" id="add_stock">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Add Stock to Main Center</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label">Course</label>
                    <CommonSelect
                      options={courseOptions}
                      value={courseOptions.find(opt => opt.value === courseId)}
                      onValueChange={(val) => setCourseId(val)}
                      placeholder="Select Course"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Quantity to Add</label>
                    <input
                      type="number"
                      className="form-control"
                      value={quantity}
                      onChange={(e) => setQuantity(Number(e.target.value))}
                      required
                      min="1"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={isLoading}>
                {isLoading ? "Saving..." : "Add Stock"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStockModal;
